import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../contexts/authContext';
import { useResolveAction } from '../../../lib/access/useResolveAction';
import { portfolioClient } from '../../../lib/connect/clients';
export const strategyKey = (id)=>[
        'landscape-strategy',
        id
    ];
export function useLandscapeStrategyKey(id) {
    const { user } = useAuth();
    return [
        ...strategyKey(id),
        user?.tenant_id ?? '',
        user?.id ?? ''
    ];
}
export function useLandscapeComparison(id) {
    const key = useLandscapeStrategyKey(id);
    return useQuery({
        queryKey: [
            ...key,
            'comparison'
        ],
        enabled: !!key[2] && !!key[3],
        queryFn: ()=>portfolioClient.getLandscapeComparison({
                landscapeId: id
            }),
        retry: false
    });
}
export function useLandscapeIntelligence(id, selectable = false) {
    const key = useLandscapeStrategyKey(id);
    return useQuery({
        queryKey: [
            ...key,
            'intelligence',
            selectable
        ],
        enabled: !!key[2] && !!key[3],
        queryFn: ()=>portfolioClient.listLandscapeIntelligence({
                landscapeId: id,
                selectable
            }),
        retry: false
    });
}
export function useLandscapeWriteAccess() {
    const { user } = useAuth();
    return useResolveAction({
        kind: 'opportunity',
        id: user?.tenant_id ?? '',
        objectType: 'identity.tenants',
        objectId: user?.tenant_id ?? ''
    }, 'update');
}
